import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
interface Testimonial {
  name: string;
  location: string;
  role?: string;
  text: string;
}
interface TestimonialsProps {
  testimonials: Testimonial[];
}
export function Testimonials({
  testimonials
}: TestimonialsProps) {
  return <section className="w-full bg-[#0a1410] py-8 md:py-16" data-id="element-246">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-247">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-248">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-[#0f1f17] border border-amber-900/30 rounded-lg p-6" data-id="element-249">
              {/* Stars */}
              <div className="flex gap-1 mb-4" data-id="element-250">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-amber-500 text-amber-500" data-id="element-251" />)}
              </div>

              {/* Testimonial Text */}
              <p className="text-gray-300 mb-4 leading-relaxed" data-id="element-252">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="text-sm" data-id="element-253">
                <p className="text-white font-semibold" data-id="element-254">{testimonial.name}</p>
                <p className="text-gray-400" data-id="element-255">
                  {testimonial.location}
                  {testimonial.role && ` · ${testimonial.role}`}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}